var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7924 12.9706C10.3921 13.4906 9.6079 13.4906 9.20759 12.9706L0.847071 2.10999C0.340874 1.45243 0.809637 0.5 1.63948 0.5L18.3605 0.5C19.1904 0.5 19.6591 1.45243 19.1529 2.10999L10.7924 12.9706Z",
    fill: "#5801FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoArrow);
export default __webpack_public_path__ + "static/media/info-arrow.e4910e06dabacba8822143ac3a595501.svg";
export { ForwardRef as ReactComponent };